import colors from '../colors';
import { buildGet } from '../../utils/typography/get';
import { buildTypes } from '../../utils/typography/types';
import buildClasses from '../../utils/typography/buildClasses';
import { buildGetTw } from '../../utils/typography/getTw';
export const family = {
  opensans: '"Open Sans", sans-serif, Tahoma, Arial',
  montserrat: '"Montserrat", sans-serif'
};
export const weight = {
  extraBold: '800',
  bold: '700',
  semiBold: '600',
  medium: '500',
  light: '400',
  regular: '400'
};
export const config = {
  '3XL': {
    lineHeight: '72px',
    color: colors.primary.black,
    fontFamily: family.montserrat,
    fontSize: '72px',
    fontWeight: weight.extraBold,
    letterSpacing: '0',
    textTransform: 'capitalize'
  },
  '2XL': {
    lineHeight: '64px',
    color: colors.primary.black,
    fontFamily: family.montserrat,
    fontSize: '60px',
    fontWeight: weight.extraBold,
    letterSpacing: '0',
    textTransform: 'capitalize'
  },
  XL: {
    lineHeight: '48px',
    color: colors.primary.black,
    fontFamily: family.montserrat,
    fontSize: '46px',
    fontWeight: weight.extraBold,
    letterSpacing: '0',
    textTransform: 'none'
  },
  large: {
    lineHeight: '40px',
    color: colors.primary.black,
    fontFamily: family.montserrat,
    fontSize: '36px',
    fontWeight: weight.extraBold,
    letterSpacing: '0',
    textTransform: 'capitalize'
  },
  MExtra: {
    lineHeight: '28px',
    color: colors.primary.black,
    fontFamily: family.montserrat,
    fontSize: '24px',
    fontWeight: weight.extraBold,
    letterSpacing: '0',
    textTransform: 'capitalize'
  },
  MSemi: {
    lineHeight: '28px',
    color: colors.primary.black,
    fontFamily: family.montserrat,
    fontSize: '24px',
    fontWeight: weight.semiBold,
    letterSpacing: '0',
    textTransform: 'capitalize'
  },
  SExtra: {
    lineHeight: '24px',
    color: colors.primary.black,
    fontFamily: family.montserrat,
    fontSize: '18px',
    fontWeight: weight.extraBold,
    letterSpacing: '0',
    textTransform: 'capitalize'
  },
  SSemi: {
    lineHeight: '24px',
    color: colors.primary.black,
    fontFamily: family.montserrat,
    fontSize: '18px',
    fontWeight: weight.semiBold,
    letterSpacing: '0',
    textTransform: 'capitalize'
  },
  XSExtra: {
    lineHeight: '16px',
    color: colors.primary.black,
    fontFamily: family.montserrat,
    fontSize: '14px',
    fontWeight: weight.extraBold,
    letterSpacing: '0.5px',
    textTransform: 'none'
  },
  XSSemi: {
    lineHeight: '16px',
    color: colors.primary.black,
    fontFamily: family.montserrat,
    fontSize: '14px',
    fontWeight: weight.semiBold,
    letterSpacing: '0.5px',
    textTransform: 'none'
  },
  XSMedium: {
    lineHeight: '16px',
    color: colors.primary.black,
    fontFamily: family.montserrat,
    fontSize: '14px',
    fontWeight: weight.medium,
    letterSpacing: '0.5px',
    textTransform: 'none'
  },
  XXS: {
    lineHeight: '12px',
    color: colors.primary.black,
    fontFamily: family.montserrat,
    fontSize: '10px',
    fontWeight: weight.semiBold,
    letterSpacing: '0',
    textTransform: 'none'
  },
  bodyXL: {
    lineHeight: '26px',
    color: colors.neutral.charcoal,
    fontFamily: family.opensans,
    fontSize: '18px',
    fontWeight: weight.semiBold,
    letterSpacing: '0',
    textTransform: 'none'
  },
  bodyL: {
    lineHeight: '26px',
    color: colors.neutral.charcoal,
    fontFamily: family.opensans,
    fontSize: '16px',
    fontWeight: weight.regular,
    letterSpacing: '0',
    textTransform: 'none'
  },
  body: {
    lineHeight: '24px',
    color: colors.neutral.charcoal,
    fontFamily: family.opensans,
    fontSize: '14px',
    fontWeight: weight.regular,
    letterSpacing: '0',
    textTransform: 'none'
  },
  bodyWide: {
    lineHeight: '36px',
    color: colors.neutral.charcoal,
    fontFamily: family.opensans,
    fontSize: '14px',
    fontWeight: weight.regular,
    letterSpacing: '0',
    textTransform: 'none'
  },
  bodyTight: {
    lineHeight: '18px',
    color: colors.neutral.charcoal,
    fontFamily: family.opensans,
    fontSize: '14px',
    fontWeight: weight.regular,
    letterSpacing: '0',
    textTransform: 'none'
  },
  body12: {
    lineHeight: '18px',
    color: colors.neutral.charcoal,
    fontFamily: family.opensans,
    fontSize: '12px',
    fontWeight: weight.regular,
    letterSpacing: '0',
    textTransform: 'none'
  },
  bodySmall: {
    lineHeight: '12px',
    color: colors.neutral.charcoal,
    fontFamily: family.opensans,
    fontSize: '10px',
    fontWeight: weight.regular,
    letterSpacing: '0.7px',
    textTransform: 'none'
  },
  SpecialXSExtra: {
    lineHeight: '16px',
    color: colors.primary.black,
    fontFamily: family.montserrat,
    fontSize: '12px',
    fontWeight: weight.extraBold,
    letterSpacing: '0.5px',
    textTransform: 'none'
  },
  SpecialXSSemi: {
    lineHeight: '16px',
    color: colors.primary.black,
    fontFamily: family.montserrat,
    fontSize: '12px',
    fontWeight: weight.semiBold,
    letterSpacing: '0.5px',
    textTransform: 'none'
  },
  SpecialXSMedium: {
    lineHeight: '16px',
    color: colors.primary.black,
    fontFamily: family.montserrat,
    fontSize: '12px',
    fontWeight: weight.medium,
    letterSpacing: '0.5px',
    textTransform: 'none'
  },
  Breadcrumb: {
    lineHeight: '21px',
    color: colors.action.darkBrightBlue,
    fontFamily: family.opensans,
    fontSize: '12px',
    fontWeight: weight.regular,
    letterSpacing: '0.5px',
    textTransform: 'none'
  }
};
export const lineHeightDefaults = Object.keys(config).reduce((acc, key) => ({
  ...acc,
  [key]: `line-height: ${config[key].lineHeight};`
}), {});
export const fontColorDefaults = Object.keys(config).reduce((acc, key) => ({
  ...acc,
  [key]: `color: ${config[key].color};`
}), {});
export const styles = buildClasses(config);
export const defaults = buildTypes(config, false, false);
export const types = buildTypes(config, true, true);
export const getTw = buildGetTw(config);
export const get = buildGet(config);
//# sourceMappingURL=typography.js.map